<template>
  <div class="edit-product">
    <div class="breadcrumb" style="background: #fff">编辑产品</div>
    <div class="third-title" @click="asd"><span>基本信息</span></div>
    <div class="order-detail-basic" style="padding-top: 0">
      <el-form :model="basicInfo" label-width="170px" ref="formRef" :rules="rules" hide-required-asterisk>
        <div class="address-list">
          <el-form-item label="产品分类:" class="address-ipt">
            <el-select v-model="category.ownCategory" value-key="id" @change='basicInfo.startupsSpu = 0, getTypeSecond()' placeholder="请选择" clearable>
              <el-option v-for="item in typeFirst" :key="item.id" :label="item.categoryName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="typeSecond.length !== 0" class="address-ipt2">
            <el-select v-model="category.topCategory" value-key="id" @change='getTypeThird' placeholder="请选择" clearable>
              <el-option v-for="item in typeSecond" :key="item.id" :label="item.categoryName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="typeThird.length !== 0" class="address-ipt2">
            <el-select v-model="category.subCategory" value-key="id" @change='getTypeFourth' placeholder="请选择" clearable>
              <el-option v-for="item in typeThird" :key="item.id" :label="item.categoryName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="typeFourth.length !== 0" class="address-ipt2">
            <el-select v-model="category.category" value-key="id" placeholder="请选择" clearable>
              <el-option v-for="item in typeFourth" :key="item.id" :label="item.categoryName" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="产品名称:" prop="spuName">
          <el-input v-model="basicInfo.spuName"></el-input>
        </el-form-item>
        <el-form-item label="产品描述:" prop="spuDesc">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="basicInfo.spuDesc"></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品类型:" prop="spuType">
          <span>{{ basicInfo.spuType === 'ALBUM' ? '相册' : basicInfo.spuType === 'PHOTO_FRAME' ? '相框' : basicInfo.spuType === 'STAGE' ? '摆台' : basicInfo.spuType === 'CERIFICATE' ? '证书' :
              basicInfo.spuType === 'DESK_CALENDAR' ? '台历' : basicInfo.spuType === 'WALL_CALENDAR' ? '挂历' : basicInfo.spuType === 'CARD' ? '卡片' : basicInfo.spuType === 'ACCESSORY' ? '配件' : '未定义'
          }}</span>
        </el-form-item> -->
        <el-form-item label="产品类型:" prop="spuType">
          <el-select v-model="basicInfo.spuType" placeholder="请选择" clearable>
            <el-option v-for="item in productypeList" :key="item.dictCode" :label="item.dictValue" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品性质:" prop="propertyId">
          <span>{{ basicInfo.spuProperty === 'CUSTOM' ? '定制' : basicInfo.spuProperty === 'NORMAL' ? '通货' : '未定义' }}</span>
        </el-form-item>
        <el-form-item label="产品标签:">
          <el-button type="primary" round @click="choiceTagDialog = true">选择标签</el-button>
        </el-form-item>
        <el-form-item label="已选标签:" prop="tagList">
          <div>
            <el-table :data="tagList" border style="width: 100%">
              <el-table-column prop="label" label="标签" width="150px"></el-table-column>
              <el-table-column label="操作" width="150px">
                <template v-slot="scope">
                  <span class="color-blue" @click="tagList.splice(scope.$index, 1)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="是否参与折扣包:">
          <el-switch v-model="basicInfo.discountBundle" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否调色:" v-if="$route.query.isSeries === 'false'">
          <el-switch v-model="basicInfo.colorGrading" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <div v-for="(v, k) in spuComposeAreaList" :key="k">
          <el-form-item :label="$config.pageType[k] + '合成区:'" v-if="$route.query.isSeries === 'false' && basicInfo.spuProperty !== 'NORMAL'" :prop="k">
            <el-select v-model="spuComposeAreaList[k].composeArea" value-key='id' filterable placeholder="请选择" clearable>
              <el-option v-for="item in areaList" :key="item.id" :label="item.areaName" :value="item"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left:10px;" v-if="spuComposeAreaList[k].composeArea.id" round @click="areaLine = spuComposeAreaList[k].composeArea, dialogVisible = true">查看合成区属性
            </el-button>
            <el-form-item label="机器码:" label-width="60" v-if="spuComposeAreaList[k].composeArea.leftComposeCode === 'MACHINE_CODE'">
              <el-select v-model="spuComposeAreaList[k].machineCodeId" @change="$refs.formRef.validateField(k)" filterable placeholder="请选择">
                <el-option v-for="item in machineCodeList" :key="item.machineCodeName + item.id" :label="item.machineCodeName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </div>
        <el-form-item v-if="$route.query.propertyName !== '通货' && basicInfo.onSale" label="支持分辨率:">
          <!-- {{ basicInfo.spuDpi }}  --> 254,300 </el-form-item>
        <el-form-item v-if="$route.query.propertyName !== '通货' && !basicInfo.onSale" label="支持分辨率:"> 300,254 <!-- <el-radio-group v-model="basicInfo.spuDpi" style="margin-top:8px;">
            <el-radio :label="300">300</el-radio>
            <el-radio :label="254">254</el-radio>
          </el-radio-group> -->
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'false'" label="已选属性:">
          <div>
            <el-table :data="basicInfo.spuDictList" border style="width: 100%">
              <el-table-column prop="propKey" label="属性" width="150px"></el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="特殊排版:">
          <el-switch v-model="basicInfo.specialLayout" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
          <span style="color:#F56C6C;width: 100%;margin-left: 10px;">此设置为：首页左半页留白，尾页右半页留白的相册产品</span>
        </el-form-item>
        <el-form-item label="是否初创产品:" v-if="category.ownCategory.id == '10'"><el-switch v-model="basicInfo.startupsSpu" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1"
            :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="在线设计:">
          <el-checkbox-group v-model="onlineDesign">
            <el-checkbox :label="1" :disabled="onlineDesign[0] == 4 || onlineDesign[1] == 4">选模板(含DIY)</el-checkbox>
            <el-checkbox :label="2">智能设计</el-checkbox>
            <el-checkbox :label="4" :disabled="onlineDesign[0] == 1 || onlineDesign[1] == 1">选模板(不含DIY)</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'false' && basicInfo.whitePage !== undefined && $route.query.propertyName !== '通货'" label="白页:">
          <div>
            <el-table :data="[basicInfo.whitePage]" border style="width: 100%">
              <el-table-column prop="whitePageName" label="白页名称" width="200px"></el-table-column>
              <el-table-column prop="date" label="白页出现位置" width="200px">
                <template slot-scope="scope">
                  <p>封面：{{ getWhitePositionName(scope.row.whitePageCoverPosition) }}</p>
                  <p>内页：{{ getWhitePositionName(scope.row.whitePageTextPosition) }}</p>
                  <p>单页：{{ getWhitePositionName(scope.row.whitePageSinglePosition) }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'false' && basicInfo.pageNumber !== undefined && $route.query.propertyName !== '通货'" label="内页页码:">
          <div>
            <el-table :data="[basicInfo.pageNumber]" border style="width: 100%">
              <el-table-column prop="pageName" label="页码名称" width="200px"></el-table-column>
              <el-table-column prop="startPage" label="页码起始页" width="200px"></el-table-column>
              <el-table-column prop="pageNumber" label="每P页码数" width="200px"></el-table-column>
              <el-table-column prop="date" label="参数" width="200px">
                <template slot-scope="scope">
                  <p v-for="(item, index) in scope.row.pageNumberDetailList" :key='item.id'> 页码{{ index + 1 }}：{{ (item.portrait === 'top' ? '距上' : '距下') + ':' + item.portraitParam + 'mm,' +
                    (item.transverse === 'left' ? '距左' : '距右') + ':' + item.transverseParam + 'mm' }} </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="是否允许上传pdf:">
          <el-switch v-model="basicInfo.uploadPdf" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'false' && $route.query.propertyName !== '通货'" label="能否从尺寸匹配到此产品:">
          <el-switch v-model="basicInfo.allowMatchSize" active-color="#1473E6" inactive-color="#8c8c8c">
          </el-switch>
        </el-form-item>
        <el-form-item label="是否隐藏此产品:">
          <el-switch v-model="basicInfo.isHidden" active-color="#1473E6" inactive-color="#8c8c8c">
          </el-switch>
        </el-form-item>
        <el-form-item label="PDF产品:" v-if="$route.query.isSeries === 'false'">
          <el-switch v-model="basicInfo.isPdf" active-color="#1473E6" inactive-color="#8c8c8c" :disabled="true"></el-switch>
        </el-form-item>
        <el-form-item label="上传前PDF文件:" v-if="basicInfo.isPdf">
          <el-upload action="#" :http-request="(e) => uploadFilePdf(e, 'front')" :show-file-list="false">
            <el-button type="primary" round v-preventReClick>上传文件</el-button>
            <div slot="tip" class="el-upload__tip">{{ frontFile.pdfName }} <i class="el-icon-circle-close" style="cursor:pointer;color:red !important;" v-if="frontFile.pdfName"
                @click="deletePdf('front')"></i></div>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传后PDF文件:" v-if="basicInfo.isPdf">
          <el-upload action="#" :http-request="(e) => uploadFilePdf(e, 'after')" :show-file-list="false">
            <el-button type="primary" round v-preventReClick>上传文件</el-button>
            <div slot="tip" class="el-upload__tip">{{ afterFile.pdfName }} <i class="el-icon-circle-close" style="cursor:pointer;color:red !important;" v-if="afterFile.pdfName"
                @click="deletePdf('after')"></i></div>
          </el-upload>
        </el-form-item>
        <el-form-item label="前后PDF上传总P数:" prop="pdfFixedNums" v-if="basicInfo.isPdf">
          <!-- <el-input v-model="basicInfo.pdfFixedNums" type="number"></el-input> -->
          <el-input-number v-model="basicInfo.pdfFixedNums" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="是否修改pdf尺寸:" v-if="basicInfo.isPdf">
          <el-switch v-model="basicInfo.isModifyPdfSize" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item label="PDF插入页序:" prop="pdfPosition" v-if="basicInfo.isPdf">
          <!-- <el-input v-model="basicInfo.pdfPosition" type="number"></el-input> -->
          <el-input-number v-model="basicInfo.pdfPosition" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="模板页总页数:" prop="pdfTemplateNums" v-if="basicInfo.isPdf">
          <!-- <el-input v-model="basicInfo.pdfTemplateNums" type="number"></el-input> -->
          <el-input-number v-model="basicInfo.pdfTemplateNums" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="PDF不进入到合成页序:" prop="pdfNoComposePage" v-if="basicInfo.isPdf">
          <!-- <el-input v-model="basicInfo.pdfNoComposePage" type="number"></el-input> -->
          <el-input-number v-model="basicInfo.pdfNoComposePage" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="SAAS端能否读取此产品:">
          <el-switch v-model="basicInfo.isPushSaas" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item label="DIY收选片:" v-if="$route.query.isSeries === 'false'">
          <el-switch v-model="basicInfo.isDiy" active-color="#1473E6" inactive-color="#8c8c8c" :disabled="basicInfo.isPdf ? true : false"></el-switch>
        </el-form-item>
        <el-form-item label="是否推送到C端:" v-if="$route.query.isSeries === 'false'">
          <!-- <el-switch v-model="basicInfo.isPushTerminal" active-color="#1473E6" inactive-color="#8c8c8c" :disabled="basicInfo.onSale && isPushTerminal === false ? true : false">
          </el-switch><span v-if='basicInfo.onSale && isPushTerminal === false'>ps:已经上架的产品不能开启推送到C端</span> -->
          <el-switch v-model="basicInfo.isPushTerminal" active-color="#1473E6" inactive-color="#8c8c8c">
          </el-switch>
        </el-form-item>
        <!-- <el-form-item label="单SKU组产品:">
          <el-switch v-model="basicInfo.isSingleSkuGroup" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item> -->
        <!-- <el-form-item label="DIY收选片:" v-show="basicInfo.isPushTerminal" v-if="$route.query.isSeries === 'false'">
          <el-switch v-model="basicInfo.isDiy" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item> -->
        <el-form-item label="是否开码:" v-show="basicInfo.isPushTerminal" v-if="$route.query.isSeries === 'false'">
          <el-switch v-model="basicInfo.isHavePromoCode" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item label="纪念日台历:" v-show="basicInfo.isPushTerminal" v-if="$route.query.isSeries === 'false'">
          <!--  :disabled='basicInfo.onSale && isCommemorationDay === false ? true : false' -->
          <el-switch v-model="basicInfo.isCommemorationDay" active-color="#1473E6" inactive-color="#8c8c8c" @change="isComDayChange"></el-switch>
          <!-- <span v-if='basicInfo.onSale && isCommemorationDay === false'>ps:已经上架的产品不能开启纪念日台历,请下架后开启</span> -->
        </el-form-item>
        <el-form-item label="是否云端设计:" v-show="basicInfo.isPushTerminal" v-if="$route.query.isSeries === 'false'">
          <el-switch v-model="basicInfo.isCloudDesign" active-color="#1473E6" inactive-color="#8c8c8c" :disabled="basicInfo.isCommemorationDay ? true : false"></el-switch>
        </el-form-item>
        <el-form-item label="产品价格是否唯一:" v-if="$route.query.isSeries === 'false'">
          <el-switch v-model="basicInfo.singlePrice" active-color="#1473E6" inactive-color="#8c8c8c" :disabled="true"></el-switch></el-form-item>
        <el-form-item label="上传补页:" prop="spuPdfAddPageVO">
          <input @change="fileChange($event, 'spuPdfAddPageVO')" type="file" id="upload_file_pdf" multiple style="display: none" />
          <draggable v-model="basicInfo.spuPdfAddPageVO" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="upload_warp_img">
            <div class="upload_warp_img_div" :class="index === 0 ? 'filter' : ''" v-for="(item, index) of basicInfo.spuPdfAddPageVO" :key="index">
              <div class="upload_img">
                <el-image :src="item.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[item.url]"></el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <!-- <p class="upload_warp_img_div_del color-blue" @click="fileMain(index, 'spuPdfAddPageVO')" v-show="index !== 0">设为主图</p> -->
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index, 'spuPdfAddPageVO')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left" v-show="basicInfo.spuPdfAddPageVO.length !== 3">
              <div class="upload_warp_left" @click="fileClick('upload_file_pdf')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
                <div class="">{{ basicInfo.spuPdfAddPageVO.length }}/3</div>
              </div>
            </div>
          </draggable>
        </el-form-item>
        <!-- <el-form-item label="	是否推送到C端首页:" v-show="basicInfo.isPushTerminal" v-if="$route.query.isSeries === 'false'">
          <el-switch v-model="basicInfo.isPushTerminalIndex" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item> -->
        <!-- <el-form-item label="封面合成位置:" v-if="$route.query.isSeries === 'false'">
          <el-select v-model="basicInfo.coverPosition" value-key="id" placeholder="请选择" clearable>
            <el-option label="首页" value="FIRST_PAGE"></el-option>
            <el-option label="尾页" value="LAST_PAGE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面合成坐标:" v-if="$route.query.isSeries === 'false'"> 左：<el-input type="number" style="width:200px" v-model="basicInfo.leftParam" placeholder=""><template
              slot="append">mm</template></el-input> 上：<el-input style="width:200px" type="number" v-model="basicInfo.topParam" placeholder=""><template slot="append">mm</template></el-input>
        </el-form-item> -->
        <el-form-item class="noleft-third-title">
          <div class="third-title"><span>产品详情</span></div>
        </el-form-item>
        <!-- <el-form-item label="产品图片:">
          <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none">
          <div class="upload_warp_img" v-show="basicInfo.primaryImages.length!==0">
            <div class="upload_warp_img_div" v-for="(item,index) of basicInfo.primaryImages" :key="index">
              <div class="upload_img">
                <img :src="item.url">
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue" @click="fileMain(index)" v-if="index !==0">设为主图</p>
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index)">删除图片</p>
              </div>
            </div>
          </div>
          <div class="upload_warp_left" v-show="basicInfo.primaryImages.length !==5">
            <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999" @click="fileClick"></i>
            <div class="">{{ basicInfo.primaryImages.length }}/5</div>
          </div>
        </el-form-item>
        <el-form-item>
          <p style="color: #999;line-height: 22px;">按住ctrl/shift可同时批量选择多张图片上传，最多可以上传5张图片，建议尺寸800*800px</p>
        </el-form-item> -->
        <el-form-item label="产品图片:" prop="primaryImages">
          <input @change="fileChange($event, 'primaryImages')" type="file" id="upload_file" multiple style="display: none">
          <draggable v-model="basicInfo.primaryImages" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="upload_warp_img">
            <div class="upload_warp_img_div" :class="index === 0 ? 'filter' : ''" v-for="(item, index) of basicInfo.primaryImages" :key="index">
              <div class="upload_img">
                <!-- <img :src="item.url"> -->
                <el-image :src="item.url" fit='contain' style="width:100%;height:100%" :preview-src-list="[item.url]"></el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue" @click="fileMain(index, 'primaryImages')" v-show="index !== 0">设为主图</p>
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index, 'primaryImages')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left" v-show="basicInfo.primaryImages.length !== getMaxImg">
              <div class="upload_warp_left" @click="fileClick('upload_file')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
                <div class="">{{ basicInfo.primaryImages.length }}/{{ getMaxImg }}</div>
              </div>
            </div>
          </draggable>
        </el-form-item>
        <el-form-item label="产品3:4图片:" prop="primaryAppImages">
          <input @change="fileChange($event, 'primaryAppImages')" type="file" id="upload_file_app" multiple style="display: none">
          <draggable v-model="basicInfo.primaryAppImages" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="upload_warp_img">
            <div class="upload_warp_img_div" :class="index === 0 ? 'filter' : ''" v-for="(item, index) of basicInfo.primaryAppImages" :key="index">
              <div class="upload_img">
                <!-- <img :src="item.url"> -->
                <el-image :src="item.url" fit='contain' style="width:100%;height:100%" :preview-src-list="[item.url]"></el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue" @click="fileMain(index, 'primaryAppImages')" v-show="index !== 0">设为主图</p>
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index, 'primaryAppImages')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left" v-show="basicInfo.primaryAppImages.length !== 5">
              <div class="upload_warp_left" @click="fileClick('upload_file_app')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
                <div class="">{{ basicInfo.primaryAppImages.length }}/5</div>
              </div>
            </div>
          </draggable>
        </el-form-item>
        <el-form-item>
          <p style="color: #999;line-height: 22px;">按住ctrl/shift可同时批量选择多张图片上传，最多可以上传5张图片</p>
        </el-form-item>
        <el-form-item label="C端首页产品图片:" v-show="basicInfo.isPushTerminal">
          <input @change="spuTerminalIndexImage($event)" type="file" id="upload_C_single_img" style="display: none">
          <div class="upload_warp_img_div" v-show="basicInfo.spuTerminalIndexImage.url">
            <div class="upload_img">
              <!-- <img :src="item.url"> -->
              <el-image :src="basicInfo.spuTerminalIndexImage.url" fit='contain' style="width:100%;height:100%" :preview-src-list="[basicInfo.spuTerminalIndexImage.url]">
              </el-image>
            </div>
            <div class="upload_warp_img_div_top">
              <p class="upload_warp_img_div_del color-blue" @click="basicInfo.spuTerminalIndexImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!basicInfo.spuTerminalIndexImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_C_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-show="basicInfo.isPushTerminal">
          <p style="color: #999;line-height: 22px;">上传一张图片，建议尺寸400*260px</p>
        </el-form-item>
        <!-- 电子卡券图片 -->
        <el-form-item label="免单电子卡券图片:" v-show="basicInfo.isHavePromoCode">
          <input @change="spuElectronicCardImageImage($event, 'upload_card_single_img')" type="file" id="upload_card_single_img" style="display: none" />
          <div class="upload_warp_img_div" v-show="basicInfo.spuElectronicCardImage.url">
            <div class="upload_img">
              <!-- <img :src="item.url"> -->
              <el-image :src="basicInfo.spuElectronicCardImage.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[basicInfo.spuElectronicCardImage.url]"></el-image>
            </div>
            <div class="upload_warp_img_div_top">
              <p class="upload_warp_img_div_del color-blue" @click="basicInfo.spuElectronicCardImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!basicInfo.spuElectronicCardImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_card_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="优惠电子卡券图片:" v-show="basicInfo.isHavePromoCode">
          <input @change="spuElectronicCardImageImage($event, 'upload_card_youhui_single_img')" type="file" id="upload_card_youhui_single_img" style="display: none" />
          <div class="upload_warp_img_div" v-show="basicInfo.spuCouponCardImage.url">
            <div class="upload_img">
              <!-- <img :src="item.url"> -->
              <el-image :src="basicInfo.spuCouponCardImage.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[basicInfo.spuCouponCardImage.url]"></el-image>
            </div>
            <div class="upload_warp_img_div_top">
              <p class="upload_warp_img_div_del color-blue" @click="basicInfo.spuCouponCardImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!basicInfo.spuCouponCardImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_card_youhui_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="免费免单电子卡券图片:" v-show="basicInfo.isHavePromoCode">
          <input @change="spuElectronicCardImageImage($event, 'upload_card_free_single_img')" type="file" id="upload_card_free_single_img" style="display: none" />
          <div class="upload_warp_img_div" v-show="basicInfo.spuFreeCardImage.url">
            <div class="upload_img">
              <el-image :src="basicInfo.spuFreeCardImage.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[basicInfo.spuFreeCardImage.url]"></el-image>
            </div>
            <div class="upload_warp_img_div_top">
              <p class="upload_warp_img_div_del color-blue" @click="basicInfo.spuFreeCardImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!basicInfo.spuFreeCardImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_card_free_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item v-show="basicInfo.isHavePromoCode">
          <!-- <el-form-item v-show="basicInfo.isPushTerminal&&basicInfo.isPushTerminalIndex"> -->
          <!-- <p style="color: #999;line-height: 22px;">上传一张图片，建议尺寸400*260px</p> -->
          <p style="color: #999;line-height: 22px;">上传一张图片，建议尺寸1063*1831px,300分辨率</p>
        </el-form-item>
        <el-form-item label="产品视频:">
          <div>
            <el-upload class="avatar-uploader upload_warp_left aaaaa" action="#" :http-request="httpRequest" v-bind:before-upload="beforeUploadVideo" v-bind:show-file-list="false">
              <video v-if="basicInfo.spuVideo.url !== ''" id='video' v-bind:src="basicInfo.spuVideo.url" class="avatar video-avatar" controls="controls" @canplaythrough="myFunction($event)">
                您的浏览器不支持视频播放 </video>
              <i v-else-if="basicInfo.spuVideo.url === ''" class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </el-upload>
            <div class="del_video" v-show="basicInfo.spuVideo.url" @click="basicInfo.spuVideo.url = ''"> 删除视频 </div>
          </div>
        </el-form-item>
        <el-form-item>
          <p style="color: #999;line-height: 22px;">1.尺寸:此处可使用1: 1或16: 9比例视频 <br> 2.时长:≤60s, 建议30秒以内短视频 <br> 3.内容:突出商品1-2个核心卖点，不建议电子相册式的图片翻页视频</p>
        </el-form-item>
        <el-form-item label="电脑详情:" prop="pcDetail">
          <el-upload class="avatar-uploader upload_warp_left" id="uploadPcDetailImg" style="display:none" action="#" :before-upload="handleBeforeUploadPc">
          </el-upload>
          <quill-editor id="editor" class="content" :options='editorOption' v-model="basicInfo.pcDetail" ref="pcQuillEditor">
          </quill-editor>
        </el-form-item>
        <el-form-item label="移动端详情:" prop="phoneDetail">
          <el-upload class="avatar-uploader upload_warp_left" id="uploadPhoneDetailImg" style="display:none" action="#" :before-upload="handleBeforeUploadPhone">
          </el-upload>
          <quill-editor id="editor2" class="content" :options='editorOptionMobile' v-model="basicInfo.phoneDetail" ref="phoneQuillEditor">
          </quill-editor>
        </el-form-item>
        <el-form-item label="产品模板:">
          <el-upload action="#" :http-request="unloadAccessory" :show-file-list="false">
            <el-button size="small" type="primary" v-preventReClick>{{ basicInfo.spuAttachmentUrl ? '重新上传' : '点击上传' }}</el-button>
            <div slot="tip" class="el-upload__tip">{{ fileName === '' ? '只能上传rar/zip文件' : '已上传：' + fileName }}</div>
          </el-upload>
          <el-button size="small" type="primary" style="margin-left:20px" v-show="basicInfo.spuAttachmentUrl" @click="basicInfo.spuAttachmentUrl = '', fileName = ''" v-preventReClick>删除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="createNewPro" v-preventReClick>以此创建新产品</el-button>
      <el-button round type="primary" @click="confirmDialog = true" v-preventReClick>确定</el-button>
    </div>
    <CombinedDialog ref="dialogRef" @addList="addNature" @selectAttr="getSelectAttr" @delete="deleteItem"></CombinedDialog>
    <!-- 查看合成区属性 -->
    <el-dialog :close-on-click-modal="false" title="查看合成区属性" :visible.sync="dialogVisible">
      <el-form ref="form" :model="areaLine" label-width="170px" inline>
        <el-form-item label="合成区:" class="address-ipt">
          <div class="area"><span>上：</span> {{ areaLine.areaTop }}mm</div>
          <div class="area"><span>下：</span> {{ areaLine.areaBottom }}mm</div>
          <div class="area"><span>左：</span> {{ areaLine.areaLeft }}mm</div>
          <div class="area"><span>右：</span> {{ areaLine.areaRight }}mm</div>
        </el-form-item>
        <el-form-item label="合成信息位置:"> {{ $config.barcodePosition[areaLine.barcodePosition] }} <el-form-item label="合成信息后是否加码:" label-width="185px"> {{ areaLine.composeAfterCodeIsAppear ? '是' : '否' }}
          </el-form-item>
          <el-form-item label="左侧合成码:" label-width="115px" style="margin-left:20px;"> {{ $config.leftComposeCode[areaLine.leftComposeCode] }} </el-form-item>
        </el-form-item>
        <el-form-item label="靠边:"> {{ areaLine.marginSize + 'mm' }} <el-form-item label="字号:" label-width="115px" style="margin-left:20px;"> {{ areaLine.fontSize + 'px' }} </el-form-item>
        </el-form-item>
        <el-form-item label="合成区任务码:">
          <el-form-item label="宽度:" label-width="55px" style="margin-left:20px;"> {{ areaLine.jobCodeWidth + 'mm' }} </el-form-item>
          <el-form-item label="高度:" label-width="55px" style="margin-left:20px;"> {{ areaLine.jobCodeHeight + 'mm' }} </el-form-item>
        </el-form-item>
        <el-form-item label="裁切线设置:"> {{ areaLine.cornerMargin + 'mm' }} </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 确定提示 -->
    <el-dialog :close-on-click-modal="false" title="确定提示" :visible.sync="confirmDialog" width="30%">
      <span>是否确认保存</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialog = false">取 消</el-button>
        <el-button type="primary" @click="updateSpu" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择产品标签 -->
    <el-dialog :close-on-click-modal="false" title="选择标签" :visible.sync="choiceTagDialog" width="30%">
      <el-table :data="allTagList" ref="tagTable" border style="width: 100%" @selection-change="handleTagChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="label" label="标签"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddTag" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import $ from 'jquery'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { addQuillTitle } from '@/assets/js/quill.js'
import draggable from 'vuedraggable'
import { areaList, areaUsable, machineCodeListNoPage, categoryQuerySub, spuSeriesAdd, spuUsable, labelGetLabelList, spuSeriesUpdate, spuUpdate, areaAdd, spuGet, categoryQuerySubs, categoryList, categoryGet, dictUsable, spuAdd, spuType, whitePosition } from '@/api/pms'
export default {
  name: 'edit-product',
  components: {
    CombinedDialog, draggable
  },
  data () {
    const toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
      ['blockquote', 'code-block'], // 引用，代码块
      [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
      [{ list: 'ordered' }, { list: 'bullet' }], // 列表
      [{ script: 'sub' }, { script: 'super' }], // 上下标
      [{ indent: '-1' }, { indent: '+1' }], // 缩进
      [{ direction: 'rtl' }], // 文本方向
      [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
      [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
      [{ font: [] }], // 字体
      [{ align: [] }], // 对齐方式
      ['clean'], // 清除字体样式
      ['image', 'video'] // 上传图片、上传视频
    ]
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('产品名称不能为空'))
      }
      // if (value.length > 40) {
      //   return callback(new Error('产品名称长度不能大于40'))
      // }
      var flag = new RegExp(this.$reg.name.reg)
      if (flag.test(value)) {
        return callback(new Error(this.$reg.name.message))
      }
      callback()
    }
    var checkCategory = (rule, value, callback) => {
      // if (this.category.categoryId !== '') {
      //   array.forEach(element => {

      //   });
      // }
      if (this.category.ownCategoryId === '') {
        return callback(new Error('未选择产品类别'))
      } else {
        callback()
      }
    }
    var COVER = (rule, value, callback) => {
      if (this.spuComposeAreaList.COVER.composeArea.leftComposeCode === 'MACHINE_CODE' && !this.spuComposeAreaList.COVER.machineCodeId) {
        return callback(new Error('未选择机器码'))
      } else {
        callback()
      }
    }
    var SINGLE = (rule, value, callback) => {
      if (this.spuComposeAreaList.SINGLE.composeArea.leftComposeCode === 'MACHINE_CODE' && !this.spuComposeAreaList.SINGLE.machineCodeId) {
        return callback(new Error('未选择机器码'))
      } else {
        callback()
      }
    }
    var TEXT = (rule, value, callback) => {
      if (this.spuComposeAreaList.TEXT.composeArea.leftComposeCode === 'MACHINE_CODE' && !this.spuComposeAreaList.TEXT.machineCodeId) {
        return callback(new Error('未选择机器码'))
      } else {
        callback()
      }
    }
    var checkMachineCodeId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('未选择机器码'))
      } else {
        callback()
      }
    }
    var checkPrimaryImages = (rule, value, callback) => {
      if (this.basicInfo.primaryImages.length === 0) {
        return callback(new Error('未上传图片'))
      } else {
        console.log('校验', this.category?.ownCategory?.id)
        if (this.category?.ownCategory?.id == 10 || this.category?.ownCategory?.id == 13) {
          console.log('婚纱分类', this.basicInfo.primaryImages.length)
          if (this.basicInfo.primaryImages.length < 3 || this.basicInfo.primaryImages.length > 10) {
            return callback(new Error('需要上传3-10张图片'))
          } else {
            callback()
          }
        } else {
          console.log('不是婚纱')
          callback()
        }
      }
    }
    var checkTagList = (rule, value, callback) => {
      if (this.tagList.length === 0) {
        return callback(new Error('请选择标签'))
      } else {
        callback()
      }
    }
    var checkAttrList = (rule, value, callback) => {
      if (this.attrList.length === 0) {
        return callback(new Error('请选择属性'))
      } else {
        callback()
      }
    }
    var checkTop = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距上规格'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(this.$reg.area.message)
      } else {
        callback()
      }
    }
    var checkBottom = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距下规格'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(this.$reg.area.message)
      } else {
        callback()
      }
    }
    var checkLeft = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距左规格'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(this.$reg.area.message)
      } else {
        callback()
      }
    }
    var checkRight = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距右规格'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(this.$reg.area.message)
      } else {
        callback()
      }
    }
    var checkWhitePage = (rule, value, callback) => {
      if (this.allowWhitePage && this.selectWhitePage.length === 0) {
        callback(new Error('请选择白页'))
      } else {
        callback()
      }
    }
    var checkPage = (rule, value, callback) => {
      if (this.allowPage && this.selectPagnation.length === 0) {
        callback(new Error('请选择页码'))
      } else {
        callback()
      }
    }
    return {
      whitePositionList: [],
      isCommemorationDay: false,
      isPushTerminal: false,
      spuComposeAreaList: {
        COVER: {
          composeArea: {},
          machineCodeId: ''
        },
        SINGLE: {
          composeArea: {},
          machineCodeId: ''
        },
        TEXT: {
          composeArea: {},
          machineCodeId: ''
        }
      },
      fileName: '',
      tagQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 5
      },
      choiceTagDialog: false,
      tagList: [],
      allTagList: [],
      awsSdk: null,
      confirmDialog: false,
      dialogVisible: false,
      category: {
        ownCategory: '',
        topCategory: '',
        subCategory: '',
        category: ''
      },
      frontFile: {
        pdfName: '',
        fixedUrl: ''
      },
      afterFile: {
        pdfName: '',
        fixedUrl: ''
      },
      onlineDesign: [],
      basicInfo: {
        discountBundle: 0,
        colorGrading: 0,
        specialLayout: 0,
        startupsSpu: 0,
        isCommemorationDay: false,
        auditStatus: 0,
        whitePage: {
          whitePageCoverPosition: '',
          whitePageTextPosition: '',
          whitePageSimplePosition: ''
        },
        pageNumber: {
          pageNumberDetailList: []
        },
        isPushSaas: false,
        isHavePromoCode: false,
        isCloudDesign: true, // 是否云端设计
        topParam: null,
        leftParam: null,
        coverPosition: '',
        isDiy: false, // DIY收选片
        singlePrice: false, // 价格是否唯一
        ownCategoryId: '',
        topCategoryId: '',
        subCategoryId: '',
        categoryId: '',
        machineCodeId: '',
        isPushTerminal: false,
        isPushTerminalIndex: false,
        spuType: '',
        composeAreaId: '',
        dictIdSet: [],
        pcDetail: '',
        isHidden: false,
        isSingleSkuGroup: false,
        phoneDetail: '',
        primaryImages: [],
        spuPdfAddPageVO: [],
        primaryAppImages: [],
        spuTerminalIndexImage: {
          url: ''
        },
        // 免单电子卡券
        spuElectronicCardImage: {
          url: ''
        },
        // 优惠电子卡券
        spuCouponCardImage: {
          url: ''
        },
        // 免费免单电子卡券
        spuFreeCardImage: {
          url: ''
        },
        spuTerminalPrimaryImages: [],
        spuProperty: {
          propertyName: ''
        },
        composeArea: {
          id: '',
          areaName: '',
          areaTop: '',
          areaBottom: '',
          areaLeft: '',
          areaRight: '',
          barcodePosition: '',
          createdTime: '',
          deleted: false,
          version: ''
        },
        propertyId: '',
        spuDesc: '',
        spuName: '',
        spuVideo: {
          mimetype: '',
          sortOrder: '',
          url: ''
        }
      },
      arrList: [],
      editorOptionMobile: {
        placeholder: '请编辑内容',
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector('#uploadPhoneDetailImg input').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      editorOption: {
        theme: 'snow',
        placeholder: '请编辑内容',
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector('#uploadPcDetailImg input').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      videoFlag: false, // 是否显示进度条
      videoUploadPercent: '', // 进度条的进度，
      isShowUploadVideo: false, // 显示上传按钮
      rules: {
        ownCategoryId: [{ validator: checkCategory, trigger: 'change' }],
        spuName: [{ validator: checkName, trigger: 'blur' }],
        spuDesc: [
          {
            required: true,
            message: '请填写产品描述'
          },
          {
            message: '产品描述不能超过50个字符',
            min: 1,
            max: 50
          }
        ],
        spuProperty: [
          {
            required: true,
            message: '请选择产品性质'
          }
        ],
        COVER: [{ validator: COVER, trigger: 'blur' }],
        SINGLE: [{ validator: SINGLE, trigger: 'blur' }],
        TEXT: [{ validator: TEXT, trigger: 'blur' }],
        // machineCodeId: [
        //   { required: true, validator: checkMachineCodeId }
        // ],
        spuDpi: [{ required: true, message: '请选择产品分辨率', trigger: 'change' }],
        allowWhitePage: [{ validator: checkWhitePage }],
        allowPage: [{ validator: checkPage }],
        phoneDetail: [
          {
            required: true,
            message: '请填写移动端详情'
          }
        ],
        pcDetail: [
          {
            required: true,
            message: '请填写电脑详情'
          }
        ],
        primaryImages: [{ validator: checkPrimaryImages, trigger: 'change' }],
        attrList: [{ validator: checkAttrList }]
        // tagList: [
        //   { validator: checkTagList }
        // ]
      },
      // rules: {
      //   ownCategoryId: [{
      //     required: true,
      //     message: '请填写产品类别'
      //   }],
      //   subCategoryId: [{
      //     required: true,
      //     message: '请填写产品类别'
      //   }],
      //   categoryId: [{
      //     required: true,
      //     message: '请填写产品类别'
      //   }],
      //   spuName: [
      //     {
      //       required: true,
      //       message: '请填写产品名称',
      //       trigger: 'blur'
      //     }, {
      //       message: '产品名称不能超过40个字符',
      //       min: 1,
      //       max: 40
      //     }
      //   ],
      //   spuDesc: [{
      //     required: true,
      //     message: '请填写产品描述'
      //   }, {
      //     message: '产品描述不能超过50个字符',
      //     min: 1,
      //     max: 50
      //   }],
      //   propertyId: [{
      //     required: true,
      //     message: '请选择产品性质'
      //   }],
      //   phoneDetail: [{
      //     required: true,
      //     message: '请填写移动端详情'
      //   }],
      //   pcDetail: [{
      //     required: true,
      //     message: '请填写电脑详情'
      //   }]
      // },
      queryId: '',
      productypeList:
        [
          {
            dictValue: '',
            dictCode: ''
          }
        ],
      typeFirst: [],
      typeSecond: [],
      typeThird: [],
      typeFourth: [],
      attrList: [],
      areaList: [],
      topBottom: '',
      topSubBottom: '',
      topThirdBottom: '',
      areaLine: {},
      machineCodeList: [],
      addAreaLineName: ''
    }
  },
  mounted () {
    addQuillTitle('editor')
    // addQuillTitle('editor2')
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$route.query.isSeries === 'false' && this.$route.query.propertyName !== '通货') {
      console.log('this.basicInfo', this.basicInfo)
      this.machineCodeListNoPage()
    }
    this.getProType()
    this.getTagList()
    this.queryId = this.$route.query.id
    this.getProCate()
    this.getAreaType()
    this.getSpuBasiceInfo()
    this.getWhitePositionList()
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    console.log(this.basicInfo.isCloudDesign)
  },
  computed: {
    getMaxImg () {
      let num = (this.category?.ownCategory?.id == 10 || this.category?.ownCategory?.id == 13) ? 10 : 5
      return num
    }
  },
  methods: {
    getWhitePositionList () {
      whitePosition().then(res => {
        if (res.data.success) {
          this.whitePositionList = res.data.data
        }
      })
    },
    getWhitePositionName (dictCode) {
      if (!dictCode) return '未定义'
      const item = this.whitePositionList.find(i => i.dictCode === dictCode)
      return item ? item.dictValue : '未定义'
    },
    // 上传pdf文件
    uploadFilePdf (e, key) {
      console.log(e, key)
      let file = e.file
      if (file.type !== 'application/pdf') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], (e) => {
      }).then(res => {
        if (res === 'error') {
          this.$message.error('服务器问题，请刷新页面重试或联系管理员')
          return
        }
        console.log(res, '11111')
        if (key === 'front') {
          this.frontFile.fixedUrl = res
          this.frontFile.pdfName = file.name
        } else {
          this.afterFile.fixedUrl = res
          this.afterFile.pdfName = file.name
        }
      })
    },
    deletePdf (type) {
      if (type === 'after') {
        this.afterFile.pdfName = ''
        this.afterFile.fixedUrl = ''
      } else {
        this.frontFile.pdfName = ''
        this.frontFile.fixedUrl = ''
      }
    },
    // 纪念日
    isComDayChange () {
      if (this.basicInfo.onSale && this.isCommemorationDay === false) {
        this.basicInfo.isCommemorationDay = false
        this.$message.error('请先下架产品再开启此开关')
      }
      // 打开纪念日台历是否云端设计关闭
      if (this.basicInfo.isCommemorationDay) {
        this.basicInfo.isCloudDesign = false
      }
    },
    // 获取产品类型
    getProType () {
      spuType('SPU_TYPE').then(res => {
        this.productypeList = res.data.data
      })
    },
    machineCodeListNoPage () {
      machineCodeListNoPage().then(res => {
        if (res.data.success) {
          this.machineCodeList = res.data.data
        }
      })
    },
    getTagList () {
      labelGetLabelList({ pageNum: this.tagQueryInfo.pageNum, pageSize: this.tagQueryInfo.pageSize, searchLabelVo: { page: 0 } }).then(res => {
        if (res.data.success) {
          this.allTagList = res.data.data.records
          this.tagQueryInfo.total = res.data.data.total
        }
      })
    },
    saveAddTag () {
      this.tagList = JSON.parse(JSON.stringify(this.choiceTagList))
      this.$refs.tagTable.clearSelection()
      this.$refs.formRef.validateField('tagList')
      this.choiceTagDialog = false
    },
    save (areaName) {
      this.addAreaLineName = areaName
      this.dialogVisible = false
      this.getAreaType()
    },
    unloadAccessory (data) {
      let file = data.file
      let fileType = file.name.slice(file.name.lastIndexOf('.'))
      if (fileType !== '.rar' && fileType !== '.zip') {
        this.$message.error('请上传正确的模板格式')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.basicInfo.spuAttachmentUrl = res
        this.fileName = file.name
      })
    },

    asd () {

    },
    // 上传产品phone端详情图片之前
    handleBeforeUploadPhone (file) {
      let _this = this
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
          var width = img.width
          if (width > 960) {
            _this.$message.error('图片宽度不能大于960')
          } else {
            _this.uploadPhoneDetailImg(file)
          }
          // 在这里可以执行其他需要图片尺寸信息的操作
        }
        img.src = e.target.result
      }
      reader.readAsDataURL(file)
      return false // 阻止默认上传行为
    },
    // 上传产品phone端详情图片
    uploadPhoneDetailImg (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/webp') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.phoneQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    // 上传产品PC端详情图片之前
    handleBeforeUploadPc (file) {
      let _this = this
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
          console.log('图片宽度:', img.width)
          console.log('图片高度:', img.height)
          var width = img.width
          // var height = img.height
          if (width > 960) {
            _this.$message.error('图片宽度不能大于960')
          } else {
            _this.uploadPcDetailImg(file)
          }
        }
        img.src = e.target.result
      }
      reader.readAsDataURL(file)
      return false // 阻止默认上传行为
    },
    // 上传产品PC端详情图片
    uploadPcDetailImg (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/webp') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.pcQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    // 创建新产品
    createNewPro () {
      // if (this.$route.query.isSeries === 'true') {
      this.basicInfo.category = this.category
      this.$router.push({
        path: '/createPro',
        query: {
          id: this.$route.query.isSeries === 'true' ? '1' : '0',
          content: JSON.stringify(this.basicInfo),
          tagList: JSON.stringify(this.tagList)
        }
      })
      // } else {
      //   this.basicInfo.category = this.category
      //   this.$router.push({
      //     path: '/createPro',
      //     query: {
      //       id: '0',
      //       content: JSON.stringify(this.basicInfo)
      //     }
      //   })
      // }
    },
    // 确定更改
    updateSpu () {
      if (this.basicInfo.isPushTerminal && this.basicInfo.spuTerminalIndexImage.url === '') {
        this.$message.error('请上传C端首页产品图片')
        return
      }
      if (this.basicInfo.isHavePromoCode && this.basicInfo.spuElectronicCardImage.url === '') {
        this.$message.error('请上传免单电子卡券图片')
        return
      }
      if (this.basicInfo.isHavePromoCode && this.basicInfo.spuCouponCardImage.url === '') {
        this.$message.error('请上传优惠电子卡券图片')
        return
      }
      // if (this.basicInfo.isHavePromoCode && this.basicInfo.spuFreeCardImage.url === '') {
      //   this.$message.error('请上传免费免单电子卡券图片')
      //   return
      // }
      if (
        !Object.keys(this.spuComposeAreaList).some(page => {
          return !!this.spuComposeAreaList[page].composeArea.id
        }) &&
        this.basicInfo.spuProperty === 'CUSTOM' &&
        +this.$route.query.id === 0
      ) {
        this.$message.error('合成区至少选一个')
        return
      }
      if (this.basicInfo.spuPdfAddPageVO.length > 0 && this.basicInfo.spuPdfAddPageVO.length < 3) {
        this.$message.error('请上传补页3张，或者不传')
        return
      }
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          setTimeout(_ => {
            var isError = document.getElementsByClassName('is-error')

            isError[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
          }, 0)
          this.confirmDialog = false
          return false
        }
        spuUsable({ act: 1, spuName: this.basicInfo.spuName, spuId: this.$route.query.id }).then(res => {
          if (!res.data.success) {
            return
          }
          let topCategoryId = this.category.ownCategory === '' ? '' : this.category.ownCategory.id
          let firstCategoryId = this.category.topCategory === '' ? '' : this.category.topCategory.id
          let secondCategoryId = this.category.subCategory === '' ? '' : this.category.subCategory.id
          let threeCategoryId = this.category.category === '' ? '' : this.category.category.id
          let categoryId = ''
          for (let k in this.category) {
            if (this.category[k].categoryName === '检视报告' || this.category[k].categoryName === 'VIP' || this.category[k].bottom || this.category[k].bottom || this.category[k].level === 3) {
              categoryId = this.category[k].id
            }
          }
          if (categoryId === '') {
            this.$message.error('未选择最底层类')
            return
          }
          console.log('afterFile', this.frontFile)
          let spuFixedPdfList = []
          if (this.frontFile.fixedUrl) {
            spuFixedPdfList.push({ ...this.frontFile, position: 'FRONT' })
          }
          if (this.afterFile.fixedUrl) {
            spuFixedPdfList.push({ ...this.afterFile, position: 'AFTER' })
          }
          if (this.$route.query.isSeries === 'true') {
            let seriesVo = {
              topCategoryId,
              firstCategoryId,
              secondCategoryId,
              threeCategoryId,
              categoryId,
              onlineDesign: this.onlineDesign.length == 1 ? this.onlineDesign[0] : (this.onlineDesign.length == 2 && this.onlineDesign.includes(1)) ? 3 : (this.onlineDesign.length == 2 && this.onlineDesign.includes(4)) ? 5 : 0,
              discountBundle: this.basicInfo.discountBundle,
              colorGrading: this.basicInfo.colorGrading,
              specialLayout: this.basicInfo.specialLayout,
              startupsSpu: this.basicInfo.startupsSpu,
              isHidden: this.basicInfo.isHidden,
              isSingleSkuGroup: this.basicInfo.isSingleSkuGroup,
              isPushTerminal: this.basicInfo.isPushTerminal,
              spuAttachmentUrl: this.basicInfo.spuAttachmentUrl,
              isPdf: this.basicInfo.isPdf,
              pdfFixedNums: this.basicInfo.pdfFixedNums,
              isModifyPdfSize: this.basicInfo.isModifyPdfSize,
              spuFixedPdfList: spuFixedPdfList,
              pdfPosition: this.basicInfo.pdfPosition,
              pdfTemplateNums: this.basicInfo.pdfTemplateNums,
              pdfNoComposePage: this.basicInfo.pdfNoComposePage,
              // categoryId: this.category.category !== '' ? this.category.category.id
              //   : this.category.subCategory !== '' ? this.category.subCategory.id
              //     : this.category.topCategory !== '' ? this.category.topCategory.id
              //       : this.category.ownCategory !== '' ? this.category.ownCategory.id : '',
              // topCategoryId: this.category.ownCategory.id,
              pcDetail: this.basicInfo.pcDetail,
              phoneDetail: this.basicInfo.phoneDetail,
              primaryImages: [],
              primaryAppImages: [],
              spuPdfAddPageVO: {},
              spuTerminalPrimaryImages: [],
              spuTerminalIndexImage: {
                sortOrder: 0,
                url: this.basicInfo.spuTerminalIndexImage.url
              },
              spuElectronicCardImage: {
                sortOrder: 0,
                url: this.basicInfo.spuElectronicCardImage.url
              },
              spuCouponCardImage: {
                sortOrder: 0,
                url: this.basicInfo.spuCouponCardImage.url
              },
              spuFreeCardImage: {
                sortOrder: 0,
                url: this.basicInfo.spuFreeCardImage.url
              },
              propertyId: this.basicInfo.propertyId,
              spuType: this.basicInfo.spuType,
              spuDesc: this.basicInfo.spuDesc,
              spuName: this.basicInfo.spuName,
              spuVideo: {
                sortOrder: 0,
                url: this.basicInfo.spuVideo.url
              },
              spuDpi: this.basicInfo.spuDpi
            }
            this.basicInfo.primaryImages.forEach((item, index) => {
              seriesVo.primaryImages.push({
                sortOrder: index,
                url: item.url
              })
            })
            this.basicInfo.primaryAppImages.forEach((item, index) => {
              seriesVo.primaryAppImages.push({
                sortOrder: index,
                url: item.url
              })
            })
            // 上传补页
            this.basicInfo.spuPdfAddPageVO.forEach((item, index) => {
              if (index == 0) {
                seriesVo.spuPdfAddPageVO.firstPage = item.url
              } else if (index == 1) {
                seriesVo.spuPdfAddPageVO.secondPage = item.url
              } else if (index == 2) {
                seriesVo.spuPdfAddPageVO.thirdPage = item.url
              }
            })
            this.basicInfo.spuTerminalPrimaryImages.forEach((item, index) => {
              seriesVo.spuTerminalPrimaryImages.push({
                sortOrder: index,
                url: item.url
              })
            })

            let spuTags = []
            this.tagList.forEach(tag => {
              spuTags.push(tag.label)
            })
            spuTags = spuTags.join(' ')
            seriesVo.spuTags = spuTags
            console.log('seriesVo', seriesVo)
            spuSeriesUpdate({ spuId: this.$route.query.id, seriesVo }).then(res => {
              if (res.data.success) {
                this.$message.success('保存成功')
                this.confirmDialog = false
                this.$router.go(-1)
              }
            })
          } else {
            let spuVO = {
              topCategoryId,
              firstCategoryId,
              secondCategoryId,
              threeCategoryId,
              categoryId,
              onlineDesign: this.onlineDesign.length == 1 ? this.onlineDesign[0] : (this.onlineDesign.length == 2 && this.onlineDesign.includes(1)) ? 3 : (this.onlineDesign.length == 2 && this.onlineDesign.includes(4)) ? 5 : 0,
              discountBundle: this.basicInfo.discountBundle,
              colorGrading: this.basicInfo.colorGrading,
              specialLayout: this.basicInfo.specialLayout,
              startupsSpu: this.basicInfo.startupsSpu,
              allowMatchSize: this.basicInfo.allowMatchSize,
              uploadPdf: this.basicInfo.uploadPdf,
              isHidden: this.basicInfo.isHidden,
              isHavePromoCode: this.basicInfo.isHavePromoCode,
              isPdf: this.basicInfo.isPdf,
              pdfFixedNums: this.basicInfo.pdfFixedNums,
              isModifyPdfSize: this.basicInfo.isModifyPdfSize,
              spuFixedPdfList: spuFixedPdfList,
              pdfPosition: this.basicInfo.pdfPosition,
              pdfTemplateNums: this.basicInfo.pdfTemplateNums,
              pdfNoComposePage: this.basicInfo.pdfNoComposePage,
              isDiy: this.basicInfo.isDiy,
              isCloudDesign: this.basicInfo.isCloudDesign,
              coverPosition: this.basicInfo.coverPosition,
              topParam: this.basicInfo.topParam,
              leftParam: this.basicInfo.leftParam,
              isPushTerminalIndex: this.basicInfo.isPushTerminalIndex,
              isSingleSkuGroup: this.basicInfo.isSingleSkuGroup,
              isPushTerminal: this.basicInfo.isPushTerminal,
              spuAttachmentUrl: this.basicInfo.spuAttachmentUrl,
              pcDetail: this.basicInfo.pcDetail,
              machineCodeId: this.basicInfo.machineCodeId,
              phoneDetail: this.basicInfo.phoneDetail,
              primaryImages: [],
              primaryAppImages: [],
              spuPdfAddPageVO: {},
              isCommemorationDay: this.basicInfo.isCommemorationDay,
              spuTerminalPrimaryImages: [],
              spuTerminalIndexImage: {
                sortOrder: 0,
                url: this.basicInfo.spuTerminalIndexImage.url
              },
              spuElectronicCardImage: {
                sortOrder: 0,
                url: this.basicInfo.spuElectronicCardImage.url
              },
              spuCouponCardImage: {
                sortOrder: 0,
                url: this.basicInfo.spuCouponCardImage.url
              },
              spuFreeCardImage: {
                sortOrder: 0,
                url: this.basicInfo.spuFreeCardImage.url
              },
              spuDesc: this.basicInfo.spuDesc,
              spuName: this.basicInfo.spuName,
              spuType: this.basicInfo.spuType,
              spuVideo: {
                sortOrder: 0,
                url: this.basicInfo.spuVideo.url
              },
              spuDpi: this.basicInfo.spuDpi
            }

            this.basicInfo.primaryImages.forEach((item, index) => {
              spuVO.primaryImages.push({
                sortOrder: index,
                url: item.url
              })
            })
            // 上传补页
            this.basicInfo.spuPdfAddPageVO.forEach((item, index) => {
              if (index == 0) {
                spuVO.spuPdfAddPageVO.firstPage = item.url
              } else if (index == 1) {
                spuVO.spuPdfAddPageVO.secondPage = item.url
              } else if (index == 2) {
                spuVO.spuPdfAddPageVO.thirdPage = item.url
              }
            })
            this.basicInfo.primaryAppImages.forEach((item, index) => {
              spuVO.primaryAppImages.push({
                sortOrder: index,
                url: item.url
              })
            })
            this.basicInfo.spuTerminalPrimaryImages.forEach((item, index) => {
              spuVO.spuTerminalPrimaryImages.push({
                sortOrder: index,
                url: item.url
              })
            })

            let spuTags = []
            this.tagList.forEach(tag => {
              spuTags.push(tag.label)
            })
            spuTags = spuTags.join(' ')
            spuVO.spuTags = spuTags

            if (this.basicInfo.spuProperty === 'CUSTOM') {
              if (
                !Object.keys(this.spuComposeAreaList).some(page => {
                  return !!this.spuComposeAreaList[page].composeArea.id
                })
              ) {
                this.$message.error('合成区至少选一个')
                return
              }

              let spuComposeAreaList = []

              Object.keys(this.spuComposeAreaList).forEach(page => {
                console.log(page)
                if (this.spuComposeAreaList[page].composeArea.id) {
                  spuComposeAreaList.push({
                    composeAreaId: this.spuComposeAreaList[page].composeArea.id,
                    machineCodeId: this.spuComposeAreaList[page].composeArea.leftComposeCode === 'MACHINE_CODE' ? this.spuComposeAreaList[page].machineCodeId : '',
                    pageTypeCode: page
                  })
                }
              })

              spuVO.spuComposeAreaList = spuComposeAreaList
            }
            console.log('spuVO', spuVO)
            spuUpdate({ spuId: this.$route.query.id, spuVO }).then(res => {
              if (res.data.success) {
                this.$message.success('保存成功')
                this.confirmDialog = false
                this.$router.go(-1)
              }
            })
          }
        })
      })
    },
    // 获取产品详情
    getSpuBasiceInfo () {
      spuGet(this.$route.query.id).then(res => {
        if (res.data.success) {
          let obj = {}
          obj = res.data.data
          // 处理分类
          let attrList = []
          if (obj.category.subCategory) {
            if (obj.category.subCategory.subCategory) {
              if (obj.category.subCategory.subCategory.subCategory) {
                attrList.push(obj.category.subCategory.subCategory.subCategory)
              }
              attrList.push(obj.category.subCategory.subCategory)
            }
            attrList.push(obj.category.subCategory)
          }
          obj.category.bottom = true
          attrList.push(obj.category)

          this.category.ownCategory = attrList[0]

          if (attrList.length >= 2) {
            this.getTypeSecond()
            this.category.topCategory = attrList[1]
          }

          if (attrList.length >= 3) {
            this.getTypeThird()
            this.category.subCategory = attrList[2]
          }

          if (attrList.length >= 4) {
            this.getTypeFourth()
            this.category.category = attrList[3]
            this.$forceUpdate()
          }

          // 处理图片
          obj.primaryImages = []
          obj.primaryAppImages = []

          obj.spuImageList.forEach((item, index) => {
            obj.primaryImages.push({
              sortOrder: index,
              url: item
            })
          })
          if (obj.spuAppImageList) {
            obj.spuAppImageList.forEach((item, index) => {
              obj.primaryAppImages.push({
                sortOrder: index,
                url: item
              })
            })
          }
          obj.spuPdfAddPageVO = []
          if (obj.spuPdfAddPage?.id) {
            for (let i = 0; i < 3; i++) {
              if (obj.spuPdfAddPage.firstPage && i == 0) {
                obj.spuPdfAddPageVO.push({
                  sortOrder: i,
                  url: obj.spuPdfAddPage.firstPage
                })
              }
              if (obj.spuPdfAddPage.secondPage && i == 1) {
                obj.spuPdfAddPageVO.push({
                  sortOrder: i,
                  url: obj.spuPdfAddPage.secondPage
                })
              }
              if (obj.spuPdfAddPage.thirdPage && i == 2) {
                obj.spuPdfAddPageVO.push({
                  sortOrder: i,
                  url: obj.spuPdfAddPage.thirdPage
                })
              }
            }
          }
          obj.spuTerminalPrimaryImages = []
          obj.spuTerminalImageList.forEach((item, index) => {
            obj.spuTerminalPrimaryImages.push({
              sortOrder: index,
              url: item
            })
          })
          obj.spuTerminalIndexImage = {
            sortOrder: 0,
            url: obj.spuTerminalIndexImage
          }
          obj.spuElectronicCardImage = {
            sortOrder: 0,
            url: obj.spuElectronicCardImage
          }
          obj.spuCouponCardImage = {
            sortOrder: 0,
            url: obj.spuCouponCardImage
          }
          obj.spuFreeCardImage = {
            sortOrder: 0,
            url: obj.spuFreeCardImage
          }
          // obj.
          if (obj.spuMachineCode) { obj.machineCodeId = obj.spuMachineCode.id }

          // 处理视频
          obj.spuVideo = {
            sortOrder: 0,
            url: obj.spuVideoUrl
          }
          // 处理标签
          this.tagList = obj.spuTags === '' || obj.spuTags === undefined ? [] : obj.spuTags.split(' ').map(item => {
            return { label: item }
          })

          // 处理合成区
          obj.composeAreaList.forEach(item => {
            // item.spuMachineCode 值为undefined 会影响后面获取,加个 ?断言
            this.spuComposeAreaList[item.pageTypeCode] = {
              composeArea: item,
              machineCodeId: item.leftComposeCode === 'MACHINE_CODE' ? item.spuMachineCode?.id || '' : ''
            }
          })
          // this.spuComposeAreaList = spuComposeAreaList

          // this.spuComposeAreaList = {
          //   COVER: {
          //     composeArea: {},
          //     machineCodeId: ''
          //   },
          //   SINGLE: {
          //     composeArea: {},
          //     machineCodeId: ''
          //   },
          //   TEXT: {
          //     composeArea: {},
          //     machineCodeId: ''
          //   }
          // }

          // this.areaLine = obj.composeArea
          this.basicInfo = obj
          this.basicInfo.specialLayout = obj.specialLayout ? 1 : 0 // 特殊排版
          this.basicInfo.startupsSpu = obj.startupsSpu ? 1 : 0 // 是否初创产品
          this.basicInfo.discountBundle = obj.discountBundle ? 1 : 0 // 是否参与折扣包
          this.basicInfo.colorGrading = obj.colorGrading ? 1 : 0
          // 在线设计
          this.onlineDesign = this.basicInfo.onlineDesign == 1 ? [1] : this.basicInfo.onlineDesign == 2 ? [2] : this.basicInfo.onlineDesign == 3 ? [1, 2] : this.basicInfo.onlineDesign == 4 ? [4] : this.basicInfo.onlineDesign == 5 ? [2, 4] : []
          console.log('onlineDesign111111', this.onlineDesign)
          console.log('obj.spuPdfAddPageVO111')
          // 前后pdf产品
          if (obj.spuFixedPdfList) {
            obj.spuFixedPdfList.forEach(file => {
              if (file.position === 'FRONT') {
                this.frontFile = file
              } else {
                this.afterFile = file
              }
            })
          }
          this.isCommemorationDay = this.basicInfo.isCommemorationDay
          // 禁用编辑期
          this.$refs.pcQuillEditor.quill.enable(false)
          this.$refs.phoneQuillEditor.quill.enable(false)

          this.$nextTick(() => {
            // 丢掉编辑器焦点并重新启用编辑器
            this.$refs.pcQuillEditor.quill.blur()
            this.$refs.pcQuillEditor.quill.enable(true)
            this.$refs.phoneQuillEditor.quill.blur()
            this.$refs.phoneQuillEditor.quill.enable(true)
          })
        }
      })
    },
    // ------------------------------------------------------------------------------------------
    addArea () {
      this.dialogVisible = false
    },
    // 获取产品类
    getProCate () {
      categoryList().then((res) => {
        this.typeFirst = res.data.data
      })
    },
    // 获取合成区类型
    getAreaType () {
      areaList().then((res) => {
        if (res.data.success) {
          this.areaList = res.data.data
          if (this.addAreaLineName !== '') {
            res.data.data.forEach(item => {
            })
          }
        }
      })
    },
    // 获取二级产品类别
    getTypeSecond () {
      let num = this.category.ownCategory.id
      if (num === undefined) {
        this.category.topCategory = ''
        this.category.subCategory = ''
        this.category.category = ''
        this.typeSecond = []
        this.typeThird = []
        this.typeFourth = []
        return false
      }
      categoryQuerySubs(num).then((res) => {
        if (res.data.success) {
          this.typeSecond = res.data.data
          if (res.data.data.length === 0) {
            this.category.topCategory = ''
            this.category.subCategory = ''
            this.category.category = ''
            this.typeThird = []
            this.typeFourth = []
            return
          }
          if (this.category.topCategory.id) {
            let num = res.data.data.filter(item => {
              return item.id === this.category.topCategory.id
            })

            if (num.length === 0) {
              this.category.topCategory = ''
              this.category.subCategory = ''
              this.category.category = ''
              this.typeThird = []
              this.typeFourth = []
            }
          }
        } else {

        }
      })
    },
    // 获取三级产品类别
    getTypeThird () {
      let num = this.category.topCategory.id
      if (num === undefined) {
        this.category.subCategory = ''
        this.category.category = ''
        this.typeThird = []
        this.typeFourth = []
        return false
      }
      this.$forceUpdate()
      categoryQuerySubs(num).then((res) => {
        if (res.data.success) {
          this.typeThird = res.data.data
          if (this.category.subCategory.id) {
            let num = res.data.data.filter(item => {
              return item.id === this.category.subCategory.id
            })

            if (num.length === 0) {
              this.category.subCategory = ''
              this.category.category = ''
              this.typeFourth = []
            }
          }
        } else {

        }
      })
    },
    // 获取四级产品类别
    getTypeFourth () {
      let num = this.category.subCategory.id
      if (num === undefined) {
        this.category.category = ''
        this.typeFourth = []
        return false
      }
      categoryQuerySubs(num).then((res) => {
        if (res.data.success) {
          this.typeFourth = res.data.data
          if (this.category.category.id) {
            let num = res.data.data.filter(item => {
              return item.id === this.category.category.id
            })

            if (num.length === 0) {
              this.category.category = ''
            }
          }
        } else {

        }
      })
    },
    // 检查产品名称是否重复
    getProName () {
      dictUsable(this.basicInfo.spuName).then((res) => {
      })
    },
    fileClick (id) {
      if (id === 'upload_C_single_img') {
        document.getElementById('upload_C_single_img').value = null
        document.getElementById('upload_C_single_img').click()
        return
      }
      if (id === 'upload_card_single_img') {
        document.getElementById('upload_card_single_img').value = null
        document.getElementById('upload_card_single_img').click()
        return
      }
      if (id === 'upload_card_youhui_single_img') {
        document.getElementById('upload_card_youhui_single_img').value = null
        document.getElementById('upload_card_youhui_single_img').click()
        return
      }
      if (id === 'upload_card_free_single_img') {
        document.getElementById('upload_card_free_single_img').value = null
        document.getElementById('upload_card_free_single_img').click()
        return
      }
      if (this.category?.ownCategory?.id == 10 || this.category?.ownCategory?.id == 13) {
        if (this.basicInfo.primaryImages.length > 10) {
          this.$message.warning('最多可上传10张图片')
          return
        }
      } else {
        if (this.basicInfo.primaryImages.length > 5) {
          this.$message.warning('已上传5张图片')
          return
        }
      }
      if (this.basicInfo.spuPdfAddPageVO.length > 3) {
        this.$message.warning('已上传3张图片')
        return
      }
      if (this.basicInfo.primaryAppImages.length > 5) {
        this.$message.warning('已上传5张图片')
        return
      }
      document.getElementById(id).click()
    },
    fileChange (el, listName) {
      if (this.category?.ownCategory?.id == 10 || this.category?.ownCategory?.id == 13) {
        if (this.basicInfo[listName].length > 10) return
      } else {
        if (this.basicInfo[listName].length > 5) return
      }
      this.fileList(el.target.files, listName)
      el.target.value = ''
    },
    fileList (files, listName) {
      if (listName == 'spuPdfAddPageVO') {
        if (files.length > 3 || (files.length + this.basicInfo[listName].length) > 3) {
          this.$message.warning('最多上传3张图片')
          return
        }
      } else if (listName == 'primaryImages') {
        if (this.category?.ownCategory?.id == 10 || this.category?.ownCategory?.id == 13) {
          if (files.length > 10 || files.length + this.basicInfo[listName].length > 10) {
            this.$message.warning('最多上传10张图片')
            return
          }
        } else {
          if (files.length > 5 || files.length + this.basicInfo[listName].length > 5) {
            this.$message.warning('最多上传5张图片')
            return
          }
        }
      } else {
        if (files.length > 5 || files.length + this.basicInfo[listName].length > 5) {
          this.$message.warning('最多上传5张图片')
          return
        }
      }
      for (let i = 0; i < files.length; i++) {
        this.fileSize(files[i], listName)
      }
    },
    fileSize (file, listName) {
      // var isAllow = fasle
      // 读取图片数据
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = async function () {
          var width = image.width
          var height = image.height
          if (listName == 'primaryImages') {
            if (_this.category?.ownCategory?.id == 10 || _this.category?.ownCategory?.id == 13) {
              // if (width == 960 && height == 1080) {
              await _this.fileAdd(file, listName)
              // } else {
              //   _this.$message.error('图片长宽需要为960*1080')
              // }
            } else {
              if (width === height) {
                await _this.fileAdd(file, listName)
              } else {
                _this.$message.error('图片长宽不相同')
              }
            }
          } else if (listName == 'spuPdfAddPageVO') {
            await _this.fileAdd(file, listName)
          } else {
            if (width / height === 3 / 4) {
              await _this.fileAdd(file, listName)
            } else {
              _this.$message.error('图片长宽不是3:4')
            }
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    async fileAdd (file, listName) {
      console.log('file', file)
      if (listName == 'spuPdfAddPageVO') {
        if (['image/jpg', 'image/jpeg'].indexOf(file.type) === -1) {
          this.$message.warning('请上传jpg格式的图片')
          return false
        }
      } else {
        if (['image/png', 'image/jpg', 'image/jpeg', 'image/svg', 'image/svg+xml', 'image/webp'].indexOf(file.type) === -1) {
          this.$message.warning('请上传正确的图片格式')
          return false
        }
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      await uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], (precent) => {
      }, 280, 280)
        .then(res => {
          this.basicInfo[listName].push({
            url: res,
            mimetype: file.type,
            sortOrder: this.basicInfo[listName].length
          })
          this.$refs.formRef.validateField(listName)
        })
      // this.size = this.size + file.size// 总大小
    },
    spuTerminalIndexImage (e) {
      console.log(e)
      let file = e.target.files[0]
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], (precent) => {
      }, 280, 280)
        .then(res => {
          this.basicInfo.spuTerminalIndexImage = {
            url: res,
            mimetype: file.type,
            sortOrder: 0
          }
        })
    },
    // 上传电子卡券
    spuElectronicCardImageImage (e, type) {
      console.log('上传电子卡券')
      let file = e.target.files[0]
      // if (['image/png', 'image/jpg', 'image/jpeg'].indexOf(file.type) === -1) {
      //   this.$message.warning('请上传png,jpg,jpeg格式的图片')
      //   return false
      // }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], precent => { }, 280, 280).then(res => {
        if (type === 'upload_card_single_img') {
          this.basicInfo.spuElectronicCardImage = {
            url: res,
            mimetype: file.type,
            sortOrder: 0
          }
        } else if (type === 'upload_card_free_single_img') {
          this.basicInfo.spuFreeCardImage = {
            url: res,
            mimetype: file.type,
            sortOrder: 0
          }
        } else {
          this.basicInfo.spuCouponCardImage = {
            url: res,
            mimetype: file.type,
            sortOrder: 0
          }
        }
      })
    },
    fileDel (index, listName) {
      // this.size = this.size - this.basicInfo.primaryImages[index].file.size// 总大小
      this.basicInfo[listName].splice(index, 1)
      this.addImageIndex(listName)
    },
    addImageIndex (listName) {
      this.basicInfo[listName].forEach((item, index) => {
        item.sortOrder = index
      })
    },
    // 设为主图
    fileMain (index, listName) {
      let imgList = this.basicInfo[listName]
      let img = imgList[index]
      imgList.splice(index, 1)
      imgList.unshift(img)
      this.addImageIndex(listName)
    },
    // 上传前回调
    beforeUploadVideo (file) {
      // var fileSize = file.size / 1024 / 1024 < 50
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的视频格式')
        return false
      }
      this.isShowUploadVideo = false
    },
    // 进度条
    uploadVideoProcess (event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    httpRequest (data) {
      uploadWebImg(data.file, this.$store.state.awsSdk.product.s3).then(res => {
        this.basicInfo.spuVideo.url = res
        this.basicInfo.spuVideo.mimetype = data.file.type
        this.basicInfo.spuVideo.sortOrder = 0
      })

      // let _this = this
      // let rd = new FileReader() // 创建文件读取对象
      // let file = data.file
      // rd.readAsDataURL(file) // 文件读取装换为base64类型
      // rd.onloadend = function (e) {
      //   _this.basicInfo.spuVideo.url = this.result // this指向当前方法onloadend的作用域
      //   _this.basicInfo.spuVideo.mimetype = file.type // this指向当前方法onloadend的作用域
      //   _this.basicInfo.spuVideo.sortOrder = 0
      // }
    },
    myFunction () {
      let ele = $('#video')
      let _this = this
      // var hour = parseInt((ele.duration) / 3600)
      // var second = Math.ceil(ele.duration % 60)
      var i = setInterval(function () {
        // if (ele.readyState > 0) {
        var minutes = parseInt(ele[0].duration / 60, 10)
        if (minutes > 0) {
          _this.$message.error('视频时长不能超过60s')
          _this.basicInfo.spuVideo.url = ''
        }
        clearInterval(i)
        // }
      }, 200)
    },
    addNature () {
      this.getProNature()
    },

    deleteAttr (index) {
      this.$refs.dialogRef.show('delete', '确定提示', '删除确定<br><span style="color: #999">是否确定删除</span>', this.attrList, index)
    },
    deleteItem (index) {
      this.basicInfo.dictIdSet.splice(index, 1)
    },
    getSelectAttr (val) {
      this.attrList = val
      this.attrList.forEach((item) => {
        this.basicInfo.dictIdSet.push(item.id)
      })
    },
    handleTagChange (val) {
      this.choiceTagList = val
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";

@deep: ~">>>";

.address-list {
  margin-left: 0 !important;
  display: flex;

  .address-ipt2 {
    margin-right: 0 !important;
    margin-left: 0 !important;

    @{deep} .el-form-item__content {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  @{deep} .address-ipt {
    .el-form-item__content {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  .el-form-item {
    display: inline-block;
  }
}

.el-input-number {
  line-height: 30px !important;

  /deep/ .el-input-number__increase {
    line-height: 15px !important;
  }
}
</style>
